import { forceUpdate, h, Host } from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";
export class AppInfo {
    constructor() {
        /** I18N subscriber ID */
        this.i18nSubscriberId = "";
        this.name = undefined;
        this.items = {};
        this.links = [];
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => {
            forceUpdate(this);
        });
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    onCloseClicked() {
        this.closeClicked.emit();
    }
    render() {
        const { t } = i18nProvider;
        const itemsWithoutSpecialKeys = Object.assign({}, this.items);
        delete itemsWithoutSpecialKeys.version;
        delete itemsWithoutSpecialKeys.build;
        delete itemsWithoutSpecialKeys.module;
        const items = this.items
            ? Object.assign({ version: this.items.version ? Object.assign({ label: t("app.header.version") }, this.items.version) : undefined, build: this.items.build ? Object.assign({ label: t("app.header.build") }, this.items.build) : undefined, module: this.items.module ? Object.assign({ label: t("app.header.module") }, this.items.module) : undefined }, itemsWithoutSpecialKeys) : {};
        return (h(Host, { key: '0ab333d74499a4ccf888628b332403182f440a9e' }, h("div", { key: 'fc63d3d1fdc2f4167a664a25f607f0d760864609', class: "grid" }, h("uic-tile", { key: 'fd0904c311d4785f4eee2724060cd134b3cfab90', onUicCloseClicked: () => this.onCloseClicked(), headline: this.name, "is-clickable": "false", "is-dismissable": "true", class: "tile" }, h("div", { key: 'f13bb27f5819ac3dcb09a77d59858f1ef38a8e76', class: "content" }, h("div", { key: '4cf534f6a0b1002187933bf2ce897b690dffa72c', class: "left" }, h("div", { key: 'daca9aea2d3fad1276ffdb5176c1ff209a0c7af4', class: "image" }), h("ul", { key: 'ee8360f14eb051169e43946634f11bb1be787c2d', class: "links" }, this.links.map((link) => (h("li", { key: link.href }, h("a", { href: link.href, class: "link", target: "_blank", rel: "noopener noreferrer", title: link.label }, link.label)))))), h("div", { key: '9db894de58d5124449b5af53d5e93f7fc17c474a', class: "right" }, Object.keys(items).map((key) => {
            return items[key] ? (h("uic-output", { key: key, label: items[key].label, value: items[key].value })) : null;
        })))))));
    }
    static get is() { return "uxc-app-info"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["app-info.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["app-info.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "name of the app to display in the app info"
                },
                "attribute": "name",
                "reflect": false
            },
            "items": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "AppInfoItems",
                    "resolved": "AppInfoItems",
                    "references": {
                        "AppInfoItems": {
                            "location": "import",
                            "path": "./interface",
                            "id": "src/components/app-info/interface.ts::AppInfoItems"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "items to display in the app info\neach item has a label and a value"
                },
                "defaultValue": "{}"
            },
            "links": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "{ label: string; href: string }[]",
                    "resolved": "{ label: string; href: string; }[]",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "links to display in the app info\neach link has a label and a href"
                },
                "defaultValue": "[]"
            }
        };
    }
    static get events() {
        return [{
                "method": "closeClicked",
                "name": "uxcAppInfoCloseClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "event emitted when the close button is clicked"
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=app-info.js.map
